const markup = () => {
  const html = document.querySelector('html');
  const body = document.querySelector('body');

  if (!html.classList.contains('touch')) {
    body.innerHTML +=
      '<div class="c-cursor"><span class="c-cursor__dot"></span>' +
      '<span class="c-cursor__emoji" data-icon-hover-default=\'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.6 123.6"><defs/><path fill="currentColor" d="M43.3 65.2v26.4h15.3v-6.4h-8.9V47.4c0-7.5-3.9-14.3-10.2-18.1C46.1 21.2 50.1 11.1 50.1 0h-6.4c0 22.9-19.6 41.5-43.7 41.5v6.4c2.4 0 4.8-.2 7.1-.5v17.8h36.2zm-8.3-31c5.1 2.5 8.3 7.6 8.3 13.2v11.3H13.5V46.1c8.2-2.2 15.6-6.4 21.5-11.9m45.2 56.9h6.4c0 17.9-14.7 32.5-32.7 32.5-18 0-32.6-14.6-32.6-32.5h6.4c0 14.4 11.8 26.1 26.2 26.1 14.5 0 26.3-11.7 26.3-26.1m28.4-49.6c-4.6 0-9.2-.7-13.5-2-7.6-2.4-14.5-6.7-19.7-12.6C68.6 19.4 64.9 9.8 64.9 0h-6.4c0 10.6 3.7 20.8 10.4 29.2-6.4 3.8-10.5 10.7-10.5 18.2v17.7H101V47.3c2.5.4 5 .5 7.5.5v-6.3zm-14 17.3H64.8V47.4c0-5.7 3.4-11 8.6-13.4 5.6 5.2 12.3 9.2 19.7 11.5.5.2 1 .3 1.5.4v12.9z"/></svg>\'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.6 123.6"><defs/><path fill="currentColor" d="M43.3 65.2v26.4h15.3v-6.4h-8.9V47.4c0-7.5-3.9-14.3-10.2-18.1C46.1 21.2 50.1 11.1 50.1 0h-6.4c0 22.9-19.6 41.5-43.7 41.5v6.4c2.4 0 4.8-.2 7.1-.5v17.8h36.2zm-8.3-31c5.1 2.5 8.3 7.6 8.3 13.2v11.3H13.5V46.1c8.2-2.2 15.6-6.4 21.5-11.9m45.2 56.9h6.4c0 17.9-14.7 32.5-32.7 32.5-18 0-32.6-14.6-32.6-32.5h6.4c0 14.4 11.8 26.1 26.2 26.1 14.5 0 26.3-11.7 26.3-26.1m28.4-49.6c-4.6 0-9.2-.7-13.5-2-7.6-2.4-14.5-6.7-19.7-12.6C68.6 19.4 64.9 9.8 64.9 0h-6.4c0 10.6 3.7 20.8 10.4 29.2-6.4 3.8-10.5 10.7-10.5 18.2v17.7H101V47.3c2.5.4 5 .5 7.5.5v-6.3zm-14 17.3H64.8V47.4c0-5.7 3.4-11 8.6-13.4 5.6 5.2 12.3 9.2 19.7 11.5.5.2 1 .3 1.5.4v12.9z"/></svg></span>' +
      '<span class="c-cursor__drag"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 141.6"><defs/><path fill="currentColor" d="M109.3 15c-3.6 0-6.9 1.2-9.7 3.1-2.6-5.9-8.5-10-15.3-10-3.4 0-6.6 1-9.3 2.8-2.4-6.4-8.5-11-15.7-11-7.4 0-13.7 4.9-15.9 11.6-2.6-1.7-5.7-2.7-9.1-2.7-9.2 0-16.8 7.5-16.8 16.8v20c-5.2.6-9.4 2.7-12.4 6.2-6 6.9-5.1 16.6-5 17l2.2 22.1c3.2 29.8 29 50.7 62.8 50.7 33.6 0 60.9-27.3 60.9-60.9V31.8c0-9.3-7.5-16.8-16.7-16.8zm8.2 16.8v48.9c0 28.9-23.5 52.4-52.5 52.4-29.3 0-51.6-17.7-54.3-43L8.6 67.9c0-.1-.6-6.5 3-10.6 1.5-1.6 3.4-2.7 6-3.2v10.3c0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3v-39c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2v15.1c0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3V16.7c0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2v23.9c0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3V24.3c.3-4.3 3.9-7.7 8.2-7.7 4.5 0 8.2 3.7 8.2 8.2V41.4c0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3V31.2c.3-4.3 3.9-7.6 8.2-7.6 4.4-.1 8.1 3.6 8.1 8.2z"/></svg></span>' +
      '</div>';

    const cursorDotHolder = document.querySelector('.c-cursor');

    cursorDotHolder.style.transform = `matrix(1, 0, 0, 1, ${window.innerWidth /
      2}, ${window.innerHeight / 2})`;

    // cursor move
    document.onmousemove = e => {
      cursorDotHolder.style.transform = `matrix(1, 0, 0, 1, ${e.clientX}, ${
        e.clientY
      })`;
    };

    // cursor move
    document.onmousedown = e => {
      cursorDotHolder.style.transform = `matrix(1, 0, 0, 1, ${e.clientX}, ${
        e.clientY
      })`;
    };
  }
};

const cursor = () => {
  const html = document.querySelector('html');

  if (!html.classList.contains('touch')) {
    const cursorDotHolder = document.querySelector('.c-cursor');
    const emojiHolder = document.querySelector('.c-cursor__emoji');
    const links = document.querySelectorAll(
      'a,.swiper-button-next,.swiper-button-prev,.facetwp-checkbox,.c-filterbar__item__name,.c-service__post__name,.c-service__post__services,.c-accordion__item__title, .c-cookie__action',
    );
    const draggable = document.querySelectorAll('.u-draggable__element');
    const emoji = document.querySelectorAll(
      '.u-emoji__element,[data-hover-icon]',
    );
    const invertElements = document.querySelectorAll(
      // eslint-disable-next-line no-multi-str
      '.test',
    );

    // links hovering

    if (links.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < links.length; i++) {
        links[i].onmouseenter = () => {
          cursorDotHolder.classList.add('c-cursor--hovering');
        };

        links[i].onmouseleave = () => {
          cursorDotHolder.classList.remove('c-cursor--hovering');
        };
      }
    }
    // draggable hovering

    if (draggable.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < draggable.length; i++) {
        draggable[i].onmouseenter = () => {
          cursorDotHolder.classList.add('c-cursor--draggable');
        };

        draggable[i].onmouseleave = () => {
          cursorDotHolder.classList.remove('c-cursor--draggable');
        };
      }
    }
    // emoji hovering

    if (emoji.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < emoji.length; i++) {
        emoji[i].onmouseenter = () => {
          if (emoji[i].getAttribute('data-hover-icon')) {
            emojiHolder.innerHTML = emoji[i].getAttribute('data-hover-icon');
          } else {
            emojiHolder.innerHTML = emojiHolder.getAttribute(
              'data-icon-hover-default',
            );
          }

          cursorDotHolder.classList.add('c-cursor--emoji');
        };

        emoji[i].onmouseleave = () => {
          cursorDotHolder.classList.remove('c-cursor--emoji');
        };
      }
    }

    // invert color
    if (invertElements.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < invertElements.length; i++) {
        invertElements[i].onmousemove = () => {
          cursorDotHolder.classList.add('c-cursor--inverted');
        };

        invertElements[i].onmouseleave = () => {
          cursorDotHolder.classList.remove('c-cursor--inverted');
        };
      }
    }
  }
};

const refresh = () => {
  // eslint-disable-next-line no-undef
  jQuery(document).on('facetwp-loaded', () => cursor());
};

export default { markup, cursor, refresh };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/cursor.js